var _rect, _rect2, _rect3, _rect4, _ellipse, _g, _rect5, _path, _rect6, _rect7, _ellipse2, _rect8, _path2, _rect9, _rect0, _ellipse3, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 200,
    viewBox: "0 0 310 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 200,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.0625,
    y: 22.7085,
    width: 206.759,
    height: 44.455,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 127.16,
    y: 38.7124,
    width: 147.94,
    height: 12.4474,
    rx: 6.2237,
    fill: "#A3BBD1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22.7085,
    width: 46.3426,
    height: 44.455,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.9951,
    cy: 45.6759,
    rx: 12.3271,
    ry: 12.298,
    fill: "#A3BBD1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1215_28478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.036 37.7471L104.607 30.5787C104.222 30.3566 103.747 30.3566 103.362 30.5787L90.9331 37.7471C90.5491 37.9685 90.3125 38.3775 90.3125 38.82V56.4409C90.3125 57.1254 90.869 57.6803 91.5554 57.6803H96.5271H111.442H116.414C117.1 57.6803 117.657 57.1254 117.657 56.4409V38.82C117.657 38.3775 117.42 37.9685 117.036 37.7471ZM110.199 55.2014H97.7699V52.7225H110.199V55.2014H110.199ZM110.199 50.2436H97.7699V47.7647H110.199V50.2436H110.199ZM110.199 45.2857H97.7699V42.8068H110.199V45.2857H110.199ZM115.171 55.2014H112.685V41.5673C112.685 40.8828 112.128 40.3278 111.442 40.3278H96.5271C95.8406 40.3278 95.2841 40.8828 95.2841 41.5673V55.2014H92.7983V39.5349L103.985 33.0834L115.171 39.5349V55.2014Z",
    fill: "#A3BBD1"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 79.2422,
    y: 132.836,
    width: 206.759,
    height: 44.455,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0469 162.621V149.285H92.0521V162.621H90.0469ZM94.0573 165.289V151.619C94.0573 150.219 94.5475 149.035 95.5278 148.068C96.5081 147.101 97.689 146.618 99.0703 146.618H107.76C109.163 146.618 110.35 147.101 111.319 148.068C112.288 149.035 112.773 150.219 112.773 151.619V165.289H94.0573ZM114.778 162.621V149.285H116.783V162.621H114.778ZM96.0625 163.288H102.412V156.953H99.7387V154.953H102.412V148.618H99.0703C98.246 148.618 97.5386 148.907 96.9481 149.485C96.3577 150.063 96.0625 150.774 96.0625 151.619V163.288ZM104.418 163.288H110.767V151.619C110.767 150.774 110.478 150.063 109.898 149.485C109.319 148.907 108.606 148.618 107.76 148.618H104.418V154.953H107.091V156.953H104.418V163.288Z",
    fill: "#A3BBD1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 127.336,
    y: 148.84,
    width: 147.94,
    height: 12.4474,
    rx: 6.2237,
    fill: "#A3BBD1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 132.836,
    width: 46.3426,
    height: 44.455,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.9951,
    cy: 155.803,
    rx: 12.3271,
    ry: 12.298,
    fill: "#A3BBD1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79.2422,
    y: 77.8325,
    width: 206.759,
    height: 44.455,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1862 109.84C94.9021 109.84 94.664 109.744 94.4718 109.553C94.2797 109.361 94.1836 109.123 94.1836 108.84V104.172H92.1784C91.911 104.172 91.6771 104.076 91.4766 103.885C91.276 103.693 91.1758 103.455 91.1758 103.172C91.1758 102.889 91.2705 102.651 91.4599 102.459C91.6492 102.268 91.8887 102.172 92.1784 102.172H94.1836V98.8375H92.1784C91.911 98.8375 91.6771 98.7417 91.4766 98.55C91.276 98.3583 91.1758 98.1207 91.1758 97.8373C91.1758 97.5539 91.2705 97.3163 91.4599 97.1246C91.6492 96.9329 91.8887 96.8371 92.1784 96.8371H94.1836V92.6027C94.1836 92.4713 94.2059 92.344 94.2504 92.2207C94.295 92.0975 94.373 91.9804 94.4844 91.8692L97.158 89.2019C97.3585 89.0019 97.5925 88.9019 97.8598 88.9019C98.1272 88.9019 98.3611 89.0019 98.5616 89.2019L100.533 91.1691L102.505 89.2019C102.707 89.0019 102.947 88.9019 103.225 88.9019C103.503 88.9019 103.742 89.0019 103.942 89.2019L105.914 91.1691L107.852 89.2019C108.054 89.0019 108.294 88.9019 108.572 88.9019C108.85 88.9019 109.089 89.0019 109.29 89.2019L111.963 91.8692C112.075 91.9804 112.153 92.0975 112.197 92.2207C112.242 92.344 112.264 92.4713 112.264 92.6027V96.8371H114.236C114.52 96.8371 114.758 96.9335 114.95 97.1263C115.142 97.3191 115.238 97.5581 115.238 97.8431C115.238 98.1282 115.142 98.3652 114.95 98.5541C114.758 98.7431 114.52 98.8375 114.236 98.8375H112.264V102.172H114.236C114.52 102.172 114.758 102.268 114.95 102.461C115.142 102.654 115.238 102.893 115.238 103.178C115.238 103.463 115.142 103.7 114.95 103.889C114.758 104.078 114.52 104.172 114.236 104.172H112.264V108.84C112.264 109.123 112.168 109.361 111.976 109.553C111.783 109.744 111.545 109.84 111.261 109.84H95.1862ZM96.1888 96.8371H99.5308V93.0028L97.8598 91.3358L96.1888 93.0028V96.8371ZM101.536 96.8371H104.878V93.0028L103.207 91.3358L101.536 93.0028V96.8371ZM106.917 96.8371H110.225V93.0028L108.554 91.3358L106.917 92.9695V96.8371ZM96.1888 102.172H99.5308V98.8375H96.1888V102.172ZM101.536 102.172H104.878V98.8375H101.536V102.172ZM106.917 102.172H110.225V98.8375H106.917V102.172ZM96.1888 107.84H99.5308V104.172H96.1888V107.84ZM101.536 107.84H104.878V104.172H101.536V107.84ZM106.917 107.84H110.225V104.172H106.917V107.84Z",
    fill: "#003A70"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 127.34,
    y: 93.8364,
    width: 147.94,
    height: 12.4474,
    rx: 6.2237,
    fill: "#003A70"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 77.8325,
    width: 46.3426,
    height: 44.455,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.9951,
    cy: 100.8,
    rx: 12.3271,
    ry: 12.298,
    fill: "#003A70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2777 104.657L41.1852 101.571C40.8377 101.225 40.2762 101.225 39.9286 101.571C39.5811 101.918 39.5811 102.478 39.9286 102.825L43.6539 106.541C44.0015 106.888 44.5629 106.888 44.9105 106.541L54.3394 97.1348C54.687 96.788 54.687 96.2279 54.3394 95.8812C53.9919 95.5344 53.4304 95.5344 53.0828 95.8812L44.2777 104.657Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1215_28478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.344,
    height: 27.2683,
    fill: "white",
    transform: "translate(90.3164 30.4121)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.64fb6a467de5ef04691719098ebd78b9.svg";
export { ForwardRef as ReactComponent };